import React from "react";

const Libra = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...r}>
      <path
        fill="#0250C9"
        d="M101.111 78H18.889c-1.045.046-2.034.54-2.759 1.379-.725.839-1.13 1.957-1.13 3.121s.405 2.282 1.13 3.121c.725.839 1.714 1.333 2.759 1.379h82.222c1.045-.046 2.034-.54 2.759-1.379.725-.839 1.13-1.957 1.13-3.121s-.405-2.282-1.13-3.121c-.725-.839-1.714-1.333-2.759-1.379zm-.013-17.091h-15.57v-2.78A25.527 25.527 0 0060 33a25.533 25.533 0 00-25.529 25.128v2.78H18.89a4.05 4.05 0 000 8.092h19.63a4.05 4.05 0 004.043-4.049v-6.823A17.436 17.436 0 0160 41.022a17.44 17.44 0 0117.437 17.106v6.823A4.048 4.048 0 0081.486 69h19.624a4.049 4.049 0 000-8.091h-.012z"
      ></path>
    </svg>
  );
}

export default Libra;